import { render, staticRenderFns } from "./GraficoCircular.vue?vue&type=template&id=28783219&scoped=true"
import script from "./GraficoCircular.vue?vue&type=script&lang=js"
export * from "./GraficoCircular.vue?vue&type=script&lang=js"
import style0 from "./GraficoCircular.vue?vue&type=style&index=0&id=28783219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28783219",
  null
  
)

export default component.exports